import { useEffect } from 'react';
// import { BannerHome } from '../component/BannerHome';
import { Clientes } from '../component/Clientes';
import { Cover } from '../component/Cover';
import { Footer } from '../component/Footer';
import { Header } from '../component/Header';
import { Servicios } from '../component/Servicios';
import { UniversityHome } from '../component/UniversityHome';
import '../styles/home.scss'; 

export const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className='home'>
      <Header />
      <Cover />
      <Servicios />
      <UniversityHome />
      <Clientes />
      <Footer />
    </div>
  )
}
